import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export var fetchPodcastCategories = createAsyncThunk(
  "podcasts/fetchPodcastCategories",
  async function (language, thunkApi) {
    try {
      var response = await fetch(API_BASE_URL + "/podcast-categories", {
        method: "GET",
        signal: thunkApi.signal,
        headers: {
          Accept: "application/json",
          "Accept-Language": language || "en",
        },
      });

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to retrieve podcast categories"
        );
      }

      return Array.isArray(responseData.data) ? responseData.data : [];
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

export var fetchPodcasts = createAsyncThunk(
  "podcasts/fetchPodcasts",
  async function (language, thunkApi) {
    try {
      var response = await fetch(API_BASE_URL + "/podcasts", {
        method: "GET",
        signal: thunkApi.signal,
        headers: {
          Accept: "application/json",
          "Accept-Language": language || "en",
        },
      });

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to retrieve podcasts"
        );
      }

      return {
        podcasts: Array.isArray(responseData.data) ? responseData.data : [],
        pagination: responseData.pagination || null,
      };
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

export var fetchPodcastById = createAsyncThunk(
  "podcasts/fetchPodcastById",
  async function (payload, thunkApi) {
    try {
      var podcastId = payload.podcastId;
      var language = payload.language || "en";

      var response = await fetch(
        API_BASE_URL + "/podcasts/" + encodeURIComponent(podcastId),
        {
          method: "GET",
          signal: thunkApi.signal,
          headers: {
            Accept: "application/json",
            "Accept-Language": language,
          },
        }
      );

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to retrieve podcast"
        );
      }

      return responseData.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

var initialState = {
  categories: [],
  podcasts: [],
  pagination: null,
  selectedPodcast: null,

  categoriesLoading: false,
  podcastsLoading: false,
  detailsLoading: false,

  categoriesError: "",
  podcastsError: "",
  detailsError: "",
};

var podcastsSlice = createSlice({
  name: "podcasts",
  initialState: initialState,
  reducers: {},
  extraReducers: function (builder) {
    builder
      .addCase(fetchPodcastCategories.pending, function (state) {
        state.categoriesLoading = true;
        state.categoriesError = "";
      })
      .addCase(fetchPodcastCategories.fulfilled, function (state, action) {
        state.categoriesLoading = false;
        state.categories = action.payload;
      })
      .addCase(fetchPodcastCategories.rejected, function (state, action) {
        state.categoriesLoading = false;
        state.categoriesError =
          action.payload || "Unable to retrieve podcast categories";
      })

      .addCase(fetchPodcasts.pending, function (state) {
        state.podcastsLoading = true;
        state.podcastsError = "";
      })
      .addCase(fetchPodcasts.fulfilled, function (state, action) {
        state.podcastsLoading = false;
        state.podcasts = action.payload.podcasts;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchPodcasts.rejected, function (state, action) {
        state.podcastsLoading = false;
        state.podcastsError = action.payload || "Unable to retrieve podcasts";
      })

      .addCase(fetchPodcastById.pending, function (state) {
        state.detailsLoading = true;
        state.detailsError = "";
        state.selectedPodcast = null;
      })
      .addCase(fetchPodcastById.fulfilled, function (state, action) {
        state.detailsLoading = false;
        state.selectedPodcast = action.payload;
      })
      .addCase(fetchPodcastById.rejected, function (state, action) {
        state.detailsLoading = false;
        state.detailsError = action.payload || "Unable to retrieve podcast";
      });
  },
});

export default podcastsSlice.reducer;
